var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
import { OpenFolder } from '../../state/actions/commands';
var DetailsPanelComponent = /** @class */ (function () {
    function DetailsPanelComponent(store) {
        this.store = store;
    }
    DetailsPanelComponent.prototype.openLocation = function () {
        var parent = this.store.selectSnapshot(DriveState.selectedEntryParent);
        this.store.dispatch(new OpenFolder(parent));
    };
    __decorate([
        Select(DriveState.selectedEntryOrActiveFolder),
        __metadata("design:type", Observable)
    ], DetailsPanelComponent.prototype, "entry$", void 0);
    __decorate([
        Select(DriveState.selectedEntryParent),
        __metadata("design:type", Observable)
    ], DetailsPanelComponent.prototype, "parent$", void 0);
    return DetailsPanelComponent;
}());
export { DetailsPanelComponent };
